import {useEffect, useState } from "react"

import { useCheckList } from "./CheckListContext"

import AddCheckListItem from "./AddCheckListItem"
import ButtonBar from "./ButtonBar"
import CheckListItem from "./CheckListItem"
import DeleteButton from "./DeleteButton"
import ReadOnlyField from "./ReadOnlyField"
import TextInput from "./TextInput"

const NestedChecklist = ({ctx, asTable=true}) => {

    const [rec, setRec] = useState(null)
    const { getRec } = useCheckList()

    useEffect(
        () => {
            !!ctx && setRec(getRec(ctx))
        }, [ctx, getRec]
    )


    if (asTable) {
        if (!rec) {
            return (<tr><td colSpan="8"></td></tr>)
        }
        return (
          <>
            <tr>
              <td>
                <ButtonBar rec={rec} />
              </td>
              <td>{rec.type}</td>
              <td>
                <ReadOnlyField rec={rec} fld="id" size={18} />
              </td>
              <td>
                <TextInput rec={rec} fld="label" size={45} unique={true} />
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <DeleteButton rec={rec} />
              </td>
            </tr>
            <tr>
              <td></td>
              <td colSpan={7}>
                <fieldset>
                  <legend>Checklist items</legend>
                  {!ctx.items ? (
                    <p>There currently aren't any checklist items.</p>
                  ) : (
                    <table>
                      <colgroup>
                        <col span={1} style={{ width: "5%" }} />
                        <col span={1} style={{ width: "10%" }} />
                        <col span={1} style={{ width: "20%" }} />
                        <col span={1} style={{ width: "20%" }} />
                        <col span={1} style={{ width: "20%" }} />
                        <col span={1} style={{ width: "5%" }} />
                        <col span={1} style={{ width: "20%" }} />
                        <col span={1} style={{ width: "5%" }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th></th>
                          <th>Type</th>
                          <th>ID</th>
                          <th>Label</th>
                          <th>Abbr. Label</th>
                          <th>Graded</th>
                          <th>Feedback</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {ctx.items.map((item, i) => (
                          <CheckListItem
                            key={item.id}
                            ctx={item}
                            index={i}
                            asTable={true}
                          />
                        ))}
                      </tbody>
                    </table>
                  )}
                  <hr />
                  <AddCheckListItem
                    index={ctx.lastIndex + 1}
                    phase={rec.phase}
                    subPhase={rec.subPhase}
                    parentID={rec.id}
                  />
                </fieldset>
              </td>
            </tr>
          </>
        );
    } else {
        if (!rec) {
            return (
                <div>Loading...</div>
            )
        }
        return (
            <div className="nested-checklist">
                <ButtonBar rec={rec} />
                <span>
                    <b>{rec.type}</b>
                    <ReadOnlyField rec={rec} fld="id" label="ID" />
                    <TextInput rec={rec} fld="label" label="label" unique={true} />
                    <DeleteButton rec={rec} />
                </span>
                <fieldset>
                    <legend>Checklist items</legend>
                    {ctx.items
                    ? ctx.items.map((item, i) =>
                        <CheckListItem key={item.id} ctx={item} index={i} />
                    )
                    : <p>There currently aren't any checklist items</p>
                    }
                    <AddCheckListItem
                        index={ctx.lastIndex+1}
                        phase={rec.phase}
                        subPhase={rec.subPhase}
                        parentID={rec.id}
                    />
                </fieldset>
            </div>
        )
    }

}

export default NestedChecklist